<script setup lang="ts">
withDefaults(defineProps<{ tone?: 'paper' | 'ink' }>(), { tone: 'paper' })
</script>

<template>
  <div class="ck-card" :class="`ck-card--${tone}`"><slot /></div>
</template>

<style scoped>
.ck-card { padding: var(--space-5); border-radius: var(--radius-lg); }
.ck-card--paper { background: var(--ck-cream-50); border: 1px solid var(--ck-cream-300); box-shadow: var(--shadow-sm); }
.ck-card--ink { background: var(--ck-ink-800); color: var(--ck-text-on-dark); box-shadow: var(--shadow-lg); }
</style>
